var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google/add_circle_outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66634 5.16659H7.33301V7.83325H4.66634V9.16659H7.33301V11.8333H8.66634V9.16659H11.333V7.83325H8.66634V5.16659ZM7.99967 1.83325C4.31967 1.83325 1.33301 4.81992 1.33301 8.49992C1.33301 12.1799 4.31967 15.1666 7.99967 15.1666C11.6797 15.1666 14.6663 12.1799 14.6663 8.49992C14.6663 4.81992 11.6797 1.83325 7.99967 1.83325ZM7.99967 13.8333C5.05967 13.8333 2.66634 11.4399 2.66634 8.49992C2.66634 5.55992 5.05967 3.16659 7.99967 3.16659C10.9397 3.16659 13.333 5.55992 13.333 8.49992C13.333 11.4399 10.9397 13.8333 7.99967 13.8333Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.3bf6a946.svg";
export { ForwardRef as ReactComponent };